// Top 40 DFW Metroplex Cities for Local SEO
// Organized by county for better targeting

export const dfwCities = [
  // DALLAS COUNTY
  {
    name: "Dallas",
    slug: "dallas",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75201", "75202", "75203", "75204", "75205"],
    population: "1,304,379",
    coordinates: { lat: 32.7767, lng: -96.7970 },
    nearby: ["Irving", "Garland", "Mesquite", "Richardson", "Carrollton"],
    highlights: ["Downtown Dallas", "Deep Ellum", "Uptown", "Bishop Arts District"],
    priority: 1
  },
  {
    name: "Irving",
    slug: "irving",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75014", "75015", "75016", "75017", "75038"],
    population: "256,684",
    coordinates: { lat: 32.8140, lng: -96.9489 },
    nearby: ["Dallas", "Grand Prairie", "Coppell", "Carrollton"],
    highlights: ["Las Colinas", "Toyota Music Factory", "DFW Airport"],
    priority: 1
  },
  {
    name: "Garland",
    slug: "garland",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75040", "75041", "75042", "75043", "75044"],
    population: "246,018",
    coordinates: { lat: 32.9126, lng: -96.6389 },
    nearby: ["Dallas", "Richardson", "Mesquite", "Rowlett", "Sachse"],
    highlights: ["Firewheel Town Center", "Lake Ray Hubbard"],
    priority: 1
  },
  {
    name: "Grand Prairie",
    slug: "grand-prairie",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75050", "75051", "75052", "75053", "75054"],
    population: "196,100",
    coordinates: { lat: 32.7459, lng: -96.9978 },
    nearby: ["Arlington", "Irving", "Dallas", "Mansfield"],
    highlights: ["Epic Waters Indoor Waterpark", "Lone Star Park"],
    priority: 1
  },
  {
    name: "Mesquite",
    slug: "mesquite",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75149", "75150", "75180", "75181", "75185"],
    population: "150,108",
    coordinates: { lat: 32.7668, lng: -96.5992 },
    nearby: ["Dallas", "Garland", "Balch Springs", "Sunnyvale"],
    highlights: ["Mesquite Championship Rodeo", "Town East Mall"],
    priority: 1
  },
  {
    name: "Carrollton",
    slug: "carrollton",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75006", "75007", "75010", "75011"],
    population: "133,434",
    coordinates: { lat: 32.9537, lng: -96.8903 },
    nearby: ["Plano", "Lewisville", "Farmers Branch", "Addison", "Coppell"],
    highlights: ["Historic Downtown Carrollton", "Korean Restaurant Row"],
    priority: 1
  },
  {
    name: "Richardson",
    slug: "richardson",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75080", "75081", "75082", "75083"],
    population: "121,323",
    coordinates: { lat: 32.9483, lng: -96.7299 },
    nearby: ["Dallas", "Plano", "Garland", "Murphy"],
    highlights: ["Telecom Corridor", "UT Dallas", "CityLine"],
    priority: 1
  },
  {
    name: "Cedar Hill",
    slug: "cedar-hill",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75104", "75106"],
    population: "49,371",
    coordinates: { lat: 32.5885, lng: -96.9561 },
    nearby: ["DeSoto", "Duncanville", "Grand Prairie", "Midlothian"],
    highlights: ["Cedar Hill State Park", "Uptown Village"],
    priority: 2
  },
  {
    name: "DeSoto",
    slug: "desoto",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75115"],
    population: "56,000",
    coordinates: { lat: 32.5899, lng: -96.8570 },
    nearby: ["Cedar Hill", "Lancaster", "Duncanville", "Dallas"],
    highlights: ["DeSoto Town Center", "Nance Farm"],
    priority: 2
  },
  {
    name: "Duncanville",
    slug: "duncanville",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75116", "75137", "75138"],
    population: "39,605",
    coordinates: { lat: 32.6518, lng: -96.9086 },
    nearby: ["Dallas", "DeSoto", "Cedar Hill", "Grand Prairie"],
    highlights: ["Armstrong Park", "Main Street"],
    priority: 2
  },
  {
    name: "Lancaster",
    slug: "lancaster",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75134", "75146"],
    population: "39,000",
    coordinates: { lat: 32.5921, lng: -96.7561 },
    nearby: ["DeSoto", "Dallas", "Wilmer", "Hutchins"],
    highlights: ["Historic Town Square", "Lancaster Airport"],
    priority: 2
  },
  {
    name: "Rowlett",
    slug: "rowlett",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75030", "75088", "75089"],
    population: "68,000",
    coordinates: { lat: 32.9029, lng: -96.5639 },
    nearby: ["Garland", "Rockwall", "Sachse", "Wylie"],
    highlights: ["Lake Ray Hubbard", "Sapphire Bay"],
    priority: 2
  },
  {
    name: "Coppell",
    slug: "coppell",
    county: "Dallas",
    state: "TX",
    zipCodes: ["75019"],
    population: "44,000",
    coordinates: { lat: 32.9546, lng: -97.0150 },
    nearby: ["Irving", "Lewisville", "Carrollton", "Grapevine"],
    highlights: ["Old Town Coppell", "Top-Rated Schools"],
    priority: 2
  },

  // TARRANT COUNTY
  {
    name: "Fort Worth",
    slug: "fort-worth",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76102", "76103", "76104", "76105", "76106"],
    population: "978,468",
    coordinates: { lat: 32.7555, lng: -97.3308 },
    nearby: ["Arlington", "North Richland Hills", "Keller", "Haltom City"],
    highlights: ["Stockyards", "Sundance Square", "Cultural District", "TCU"],
    priority: 1
  },
  {
    name: "Arlington",
    slug: "arlington",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76001", "76002", "76006", "76010", "76011"],
    population: "394,266",
    coordinates: { lat: 32.7357, lng: -97.1081 },
    nearby: ["Fort Worth", "Grand Prairie", "Mansfield", "Dallas"],
    highlights: ["AT&T Stadium", "Globe Life Field", "Six Flags", "UT Arlington"],
    priority: 1
  },
  {
    name: "North Richland Hills",
    slug: "north-richland-hills",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76180", "76182"],
    population: "72,000",
    coordinates: { lat: 32.8343, lng: -97.2289 },
    nearby: ["Fort Worth", "Hurst", "Richland Hills", "Haltom City", "Keller"],
    highlights: ["NRH2O Family Water Park", "Iron Horse Golf Course"],
    priority: 1
  },
  {
    name: "Mansfield",
    slug: "mansfield",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76063"],
    population: "75,000",
    coordinates: { lat: 32.5632, lng: -97.1417 },
    nearby: ["Arlington", "Grand Prairie", "Burleson", "Kennedale"],
    highlights: ["Historic Downtown", "Hawaiian Falls", "Top Schools"],
    priority: 1
  },
  {
    name: "Euless",
    slug: "euless",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76039", "76040"],
    population: "56,000",
    coordinates: { lat: 32.8371, lng: -97.0820 },
    nearby: ["Bedford", "Hurst", "Grapevine", "Irving"],
    highlights: ["DFW Airport Access", "Texas Star Golf Course"],
    priority: 1
  },
  {
    name: "Bedford",
    slug: "bedford",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76021", "76022"],
    population: "49,000",
    coordinates: { lat: 32.8440, lng: -97.1431 },
    nearby: ["Euless", "Hurst", "Colleyville", "North Richland Hills"],
    highlights: ["Boys Ranch Activity Center", "Central Location"],
    priority: 2
  },
  {
    name: "Grapevine",
    slug: "grapevine",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76051", "76099"],
    population: "54,000",
    coordinates: { lat: 32.9343, lng: -97.0781 },
    nearby: ["Southlake", "Colleyville", "Coppell", "Euless"],
    highlights: ["Historic Main Street", "Grapevine Mills", "Grapevine Lake"],
    priority: 1
  },
  {
    name: "Keller",
    slug: "keller",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76244", "76248"],
    population: "47,000",
    coordinates: { lat: 32.9346, lng: -97.2297 },
    nearby: ["Southlake", "North Richland Hills", "Fort Worth", "Watauga"],
    highlights: ["Bear Creek Park", "Old Town Keller", "Top Schools"],
    priority: 1
  },
  {
    name: "Hurst",
    slug: "hurst",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76053", "76054"],
    population: "39,000",
    coordinates: { lat: 32.8234, lng: -97.1706 },
    nearby: ["Bedford", "Euless", "North Richland Hills", "Fort Worth"],
    highlights: ["North East Mall", "Chisholm Park"],
    priority: 2
  },
  {
    name: "Southlake",
    slug: "southlake",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76092"],
    population: "32,000",
    coordinates: { lat: 32.9412, lng: -97.1342 },
    nearby: ["Grapevine", "Colleyville", "Keller", "Trophy Club"],
    highlights: ["Southlake Town Square", "Carroll ISD", "Affluent Community"],
    priority: 1
  },
  {
    name: "Colleyville",
    slug: "colleyville",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76034"],
    population: "27,000",
    coordinates: { lat: 32.8809, lng: -97.1550 },
    nearby: ["Grapevine", "Southlake", "Bedford", "Euless"],
    highlights: ["Village at Colleyville", "Grapevine-Colleyville ISD"],
    priority: 2
  },
  {
    name: "Haltom City",
    slug: "haltom-city",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76117", "76137"],
    population: "45,000",
    coordinates: { lat: 32.7996, lng: -97.2692 },
    nearby: ["Fort Worth", "North Richland Hills", "Watauga", "Richland Hills"],
    highlights: ["Buffalo Ridge Park", "Growing Business Community"],
    priority: 2
  },
  {
    name: "Burleson",
    slug: "burleson",
    county: "Tarrant",
    state: "TX",
    zipCodes: ["76028", "76097"],
    population: "49,000",
    coordinates: { lat: 32.5421, lng: -97.3208 },
    nearby: ["Fort Worth", "Mansfield", "Joshua", "Crowley"],
    highlights: ["Old Town Burleson", "Russell Farm Art Center"],
    priority: 2
  },

  // COLLIN COUNTY
  {
    name: "Plano",
    slug: "plano",
    county: "Collin",
    state: "TX",
    zipCodes: ["75023", "75024", "75025", "75074", "75075"],
    population: "285,494",
    coordinates: { lat: 33.0198, lng: -96.6989 },
    nearby: ["Dallas", "Frisco", "Richardson", "Allen", "McKinney"],
    highlights: ["Legacy West", "Shops at Legacy", "Toyota HQ", "Top Schools"],
    priority: 1
  },
  {
    name: "McKinney",
    slug: "mckinney",
    county: "Collin",
    state: "TX",
    zipCodes: ["75069", "75070", "75071", "75072"],
    population: "199,177",
    coordinates: { lat: 33.1972, lng: -96.6397 },
    nearby: ["Frisco", "Allen", "Plano", "Prosper", "Princeton"],
    highlights: ["Historic Downtown", "Adriatica Village", "Best Place to Live"],
    priority: 1
  },
  {
    name: "Frisco",
    slug: "frisco",
    county: "Collin",
    state: "TX",
    zipCodes: ["75033", "75034", "75035", "75036"],
    population: "210,719",
    coordinates: { lat: 33.1507, lng: -96.8236 },
    nearby: ["Plano", "McKinney", "The Colony", "Little Elm", "Prosper"],
    highlights: ["The Star", "Cowboys HQ", "Stonebriar Centre", "Fastest Growing"],
    priority: 1
  },
  {
    name: "Allen",
    slug: "allen",
    county: "Collin",
    state: "TX",
    zipCodes: ["75002", "75013"],
    population: "105,000",
    coordinates: { lat: 33.1032, lng: -96.6706 },
    nearby: ["Plano", "McKinney", "Frisco", "Lucas", "Fairview"],
    highlights: ["Allen Premium Outlets", "Watters Creek", "Top Schools"],
    priority: 1
  },
  {
    name: "Wylie",
    slug: "wylie",
    county: "Collin",
    state: "TX",
    zipCodes: ["75098"],
    population: "55,000",
    coordinates: { lat: 33.0151, lng: -96.5389 },
    nearby: ["Murphy", "Sachse", "Lavon", "Lucas", "Garland"],
    highlights: ["Lake Lavon", "Historic Downtown", "Growing Community"],
    priority: 2
  },
  {
    name: "Prosper",
    slug: "prosper",
    county: "Collin",
    state: "TX",
    zipCodes: ["75078"],
    population: "35,000",
    coordinates: { lat: 33.2362, lng: -96.8011 },
    nearby: ["Frisco", "McKinney", "Celina", "Little Elm"],
    highlights: ["Gates of Prosper", "Prosper ISD", "Upscale Living"],
    priority: 2
  },

  // DENTON COUNTY
  {
    name: "Denton",
    slug: "denton",
    county: "Denton",
    state: "TX",
    zipCodes: ["76201", "76205", "76207", "76208", "76209"],
    population: "148,146",
    coordinates: { lat: 33.2148, lng: -97.1331 },
    nearby: ["Lewisville", "Flower Mound", "Corinth", "Lake Dallas"],
    highlights: ["UNT", "TWU", "Denton Square", "Live Music Scene"],
    priority: 1
  },
  {
    name: "Lewisville",
    slug: "lewisville",
    county: "Denton",
    state: "TX",
    zipCodes: ["75029", "75056", "75057", "75067"],
    population: "111,822",
    coordinates: { lat: 33.0462, lng: -96.9942 },
    nearby: ["Flower Mound", "Carrollton", "The Colony", "Highland Village"],
    highlights: ["Vista Ridge Mall", "Lewisville Lake", "Old Town"],
    priority: 1
  },
  {
    name: "Flower Mound",
    slug: "flower-mound",
    county: "Denton",
    state: "TX",
    zipCodes: ["75022", "75028"],
    population: "79,000",
    coordinates: { lat: 33.0146, lng: -97.0969 },
    nearby: ["Lewisville", "Highland Village", "Grapevine", "Coppell"],
    highlights: ["The Shops at Highland Village", "Grapevine Lake", "Top Schools"],
    priority: 1
  },
  {
    name: "Little Elm",
    slug: "little-elm",
    county: "Denton",
    state: "TX",
    zipCodes: ["75068"],
    population: "60,000",
    coordinates: { lat: 33.1626, lng: -96.9375 },
    nearby: ["Frisco", "The Colony", "Prosper", "Aubrey"],
    highlights: ["Lewisville Lake", "Little Elm Park", "Fast Growing"],
    priority: 2
  },
  {
    name: "The Colony",
    slug: "the-colony",
    county: "Denton",
    state: "TX",
    zipCodes: ["75056"],
    population: "44,000",
    coordinates: { lat: 33.0901, lng: -96.8917 },
    nearby: ["Frisco", "Lewisville", "Carrollton", "Little Elm"],
    highlights: ["Grandscape", "Nebraska Furniture Mart", "Lewisville Lake"],
    priority: 2
  },
  {
    name: "Highland Village",
    slug: "highland-village",
    county: "Denton",
    state: "TX",
    zipCodes: ["75077"],
    population: "16,000",
    coordinates: { lat: 33.0918, lng: -97.0467 },
    nearby: ["Flower Mound", "Lewisville", "Double Oak"],
    highlights: ["The Shops at Highland Village", "Affluent Community"],
    priority: 2
  },

  // JOHNSON COUNTY
  {
    name: "Cleburne",
    slug: "cleburne",
    county: "Johnson",
    state: "TX",
    zipCodes: ["76031", "76033"],
    population: "32,000",
    coordinates: { lat: 32.3476, lng: -97.3867 },
    nearby: ["Burleson", "Joshua", "Keene", "Grandview"],
    highlights: ["Lake Pat Cleburne", "Historic Downtown", "County Seat"],
    priority: 2
  },

  // ROCKWALL COUNTY
  {
    name: "Rockwall",
    slug: "rockwall",
    county: "Rockwall",
    state: "TX",
    zipCodes: ["75032", "75087"],
    population: "47,000",
    coordinates: { lat: 32.9312, lng: -96.4597 },
    nearby: ["Rowlett", "Heath", "Fate", "Royse City"],
    highlights: ["Lake Ray Hubbard", "Historic Downtown", "Harbor District"],
    priority: 2
  },
  {
    name: "Trophy Club",
    slug: "trophy-club",
    county: "Denton",
    state: "TX",
    zipCodes: ["76262"],
    population: "13,000",
    coordinates: { lat: 32.9987, lng: -97.1836 },
    nearby: ["Southlake", "Roanoke", "Westlake", "Keller"],
    highlights: ["Trophy Club Country Club", "Northwest ISD"],
    priority: 2
  }
];

// Services offered for local SEO pages
export const services = [
  {
    name: "Web Design",
    slug: "web-design",
    icon: "Globe",
    description: "Custom, responsive website design that converts visitors into customers",
    keywords: ["web design", "website design", "web development", "website development"]
  },
  {
    name: "SEO Services",
    slug: "seo",
    icon: "TrendingUp",
    description: "Local and national SEO strategies to dominate search rankings",
    keywords: ["SEO", "search engine optimization", "local SEO", "SEO services"]
  },
  {
    name: "Digital Marketing",
    slug: "digital-marketing",
    icon: "Target",
    description: "Comprehensive digital marketing including PPC, social media, and content marketing",
    keywords: ["digital marketing", "online marketing", "internet marketing", "marketing agency"]
  },
  {
    name: "eCommerce Development",
    slug: "ecommerce",
    icon: "ShoppingCart",
    description: "Powerful online stores that drive sales and growth",
    keywords: ["ecommerce", "online store", "ecommerce development", "shopify"]
  },
  {
    name: "AI Web Solutions",
    slug: "ai-web-solutions",
    icon: "Bot",
    description: "AI-powered websites with chatbots, auto-blogging, and smart automation",
    keywords: ["AI website", "AI web development", "chatbot", "automation"]
  }
];

// County groupings for footer display
export const counties = [
  { name: "Dallas County", slug: "dallas-county" },
  { name: "Tarrant County", slug: "tarrant-county" },
  { name: "Collin County", slug: "collin-county" },
  { name: "Denton County", slug: "denton-county" },
  { name: "Other Areas", slug: "other-areas" }
];

// Helper function to get cities by county
export const getCitiesByCounty = (countyName) => {
  if (countyName === "Other Areas") {
    return dfwCities.filter(city => 
      !["Dallas", "Tarrant", "Collin", "Denton"].includes(city.county)
    );
  }
  return dfwCities.filter(city => city.county === countyName.replace(" County", ""));
};

// Helper function to get city by slug
export const getCityBySlug = (slug) => {
  return dfwCities.find(city => city.slug === slug);
};

// Generate longtail keywords for a city
export const generateCityKeywords = (city, service) => {
  const cityName = city.name;
  const keywords = [
    `${service.name} ${cityName}`,
    `${service.name} ${cityName} TX`,
    `${cityName} ${service.name}`,
    `${cityName} ${service.name} company`,
    `${cityName} ${service.name} agency`,
    `best ${service.name} ${cityName}`,
    `${service.name} near ${cityName}`,
    `${service.name} services ${cityName}`,
    `affordable ${service.name} ${cityName}`,
    `professional ${service.name} ${cityName} Texas`
  ];
  return keywords;
};

export default dfwCities;
